const mobile = {
  border: true,
  textAlign: 'center',
  style: { padding: '2rem' },
  rounded: '@theme:card.rounded',
  noResultsButton: {
    border: true,
    rounded: '0',
  },
  iconProps: {
    fontSize: '10',
  },
  noResultsHeader: {
    marginBottom: '4',
    fontSize: '6',
  },
};

export default mobile;
